module.exports = __webpack_public_path__ + "static/media/man-holding-phone-dark.8053b1ac.jpg";